import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaClock, FaShieldAlt } from 'react-icons/fa';
import './WhyReddicks.scss';
import Header from '../Header';
import Footer from '../Footer/Footer';
import TelegramPopup from '../../Common/TelegramPopup/TelegramPopup';

const WhyReddicks = () => {
  return (
    <div className="why-reddicks-page" data-scroll-root>
      <Header />

      <main className="why-reddicks-content why-placeholder">
        <section className="wr-hero">
          <div className="wr-hero-bg">
            <div className="wr-orb wr-orb--1"></div>
            <div className="wr-orb wr-orb--2"></div>
            <div className="wr-orb wr-orb--3"></div>
          </div>
          <div className="container">
            <span className="wr-hero__tag">Section Refresh In Progress</span>
            <h1 className="wr-hero__title">
              <span className="wr-hero__title-line">New REDDICKS Story</span>
              <span className="wr-hero__title-brand">Coming Soon</span>
            </h1>
            <p className="wr-hero__subtitle">
              Gary is preparing the next full narrative update. Until then, use
              the trust links and buy routes below.
            </p>
          </div>
        </section>

        <section className="wr-placeholder-section">
          <div className="section-divider"></div>
          <div className="container">
            <div className="wr-placeholder-grid">
              <article className="wr-placeholder-card">
                <div className="wr-placeholder-card__icon">
                  <FaShieldAlt />
                </div>
                <h3>Trust First</h3>
                <p>Review live lock and status surfaces before entering any route.</p>
                <Link to="/verify" className="cta-button wr-primary-cta">
                  Open Verify <FaArrowRight />
                </Link>
              </article>

              <article className="wr-placeholder-card">
                <div className="wr-placeholder-card__icon">
                  <FaClock />
                </div>
                <h3>Base Rollout Live</h3>
                <p>
                  Current buy and bridge context is live on the Buy page with
                  published Base contract references and live trust links.
                </p>
                <Link to="/buy" className="cta-button wr-primary-cta">
                  Open Buy Routes <FaArrowRight />
                </Link>
              </article>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <TelegramPopup />
    </div>
  );
};

export default WhyReddicks;
